// 篩選數據庫。
export const state = {
  filterRate: [
    {
      EBIDTA_per_share: 0,
      EBOA: 0,
      EBOE: 0,
      EBOIC: 0,
      per_share_EPS: 0,
      ROA: 0,
      ROE: 0,
      ROIC: 0,
      cash_reinvestment_ratio: 0,
      closing_price: 0,
      company_name: 0,
      consider_fund_reinvestment: 0,
      dividend_redistribution_ratio: 0,
      expected_reasonable_value: 0,
      gross_profit_ratio: 0,
      level: "",
      stock_symbol: 0,
      year: 0,
      go_public: "1",
      discount_ratio: 0,
      sum_of_EBIDTA: 0
    }
  ],
  ratio: {
    EBOIC: 0,
    gross_profit_ratio: 0,
    ROIC: 0,
    expected_rate_of_return: 15, //預設
    level: "A", //預設
    go_public: "1", //預設
    stock_symbol: null
  },
  errorMessage: "",

  // 給 action 用，因修改等級或狀態時需重發 table api，query 需依照勾選條件送出
  filterOptions: {
    selectStock: false, // 股票代號
    selectEBOIC: false, // EBOIC
    selectROIC: false, // ROIC
    selectProfitRatio: false // 毛利率
  }
};
